import Axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { BehaviorSubject, Subject } from 'rxjs';
import { serverSuccessInterceptor, serverErrorInterceptor } from 'src/services/axios/serverError';
import { API_URL_PREFIX } from 'src/utils/Domain/Constants';

export const currentBearerToken = new BehaviorSubject<string>('');

let unauthCb: () => void | undefined;
export function setUnauthCallback(cb: () => void): void {
  unauthCb = cb;
}

const api = Axios.create({
  baseURL: API_URL_PREFIX,
  paramsSerializer: {
    // array indexes format (null - no brackets, false (default) - empty brackets, true - brackets with indexes)
    indexes: null // This stops the default of adding brackets at the end of variables. Our api does not actually support that syntax
  }
});

async function authenticationInterceptor(config: InternalAxiosRequestConfig) {
  if (currentBearerToken.value) {
    config.headers.set('Authorization', `Bearer ${currentBearerToken.value}`);
  }
  return config;
}

function fixBaseRoute(config: InternalAxiosRequestConfig) {
  if (config.url?.includes('finplan')) {
    config.baseURL = '/';
  }
  return config;
}

api.interceptors.request.use(authenticationInterceptor);
api.interceptors.request.use(fixBaseRoute);
api.interceptors.response.use(serverSuccessInterceptor, serverErrorInterceptor);
api.interceptors.response.use(null, unauthInterceptor);

export async function unauthInterceptor(error: AxiosError): Promise<void> {
  // In theory, the token refresh should keep us happy here. However, due to computer sleep
  // or in development when the backend server changes we need to detect that we are unauthed so
  // we take action. This is set in platform.tsx
  if (error.response?.status === 401 || error.response?.status === 403) {
    unauthCb();
  }
}


export default api;
